<mat-card>
  <!-- <form>
            <input type="text" [(ngModel)]="account.name" [ngModelOptions]="{standalone: true}">
            <input type="email" [(ngModel)]="account.email" [ngModelOptions]="{standalone: true}">
            <button class="button" type="button" (click)="submit()">{{isEdit ? 'Update' : 'Create'}}</button><br>
            <button class="button" type="button" (click)="delete()">Delete</button><br>
            <a [routerLink]="[ '/accounts' ]">Back to list</a>
        </form> -->

  <mat-card-title>Account</mat-card-title>

  <form>
    <mat-form-field>
      <input
        matInput
        placeholder="Name"
        type="text"
        [(ngModel)]="account.name"
        [ngModelOptions]="{ standalone: true }"
      />
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        placeholder="Email"
        type="email"
        [(ngModel)]="account.email"
        [ngModelOptions]="{ standalone: true }"
      />
    </mat-form-field>
    <mat-card-actions>
      <a mat-raised-button routerLink="/accounts">Back to list</a>
      <a mat-raised-button color="accent" routerLink="licences/new"
        >Add new licence</a
      >
      <div>
        <button
          mat-raised-button
          color="primary"
          class="button"
          type="button"
          (click)="submit()"
        >
          {{ isEdit ? 'Update' : 'Create' }}</button
        ><br />
        <button
          mat-raised-button
          color="warn"
          class="button"
          type="button"
          (click)="delete()"
        >
          Delete</button
        ><br />
      </div>
    </mat-card-actions>
  </form>

  <div class="licences">
    <table
      mat-table
      matSort
      [dataSource]="dataSource"
      class="mat-elevation-z8"
      *ngIf="show"
    >
      <ng-container matColumnDef="typeId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type ID</th>
        <td mat-cell *matCellDef="let element">{{ element.type.id }}</td>
      </ng-container>
      <ng-container matColumnDef="period">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Period</th>
        <td mat-cell *matCellDef="let element">
          {{ element.startDate | date : 'yyyy-MM' }} -
          {{ element.endDate | date : 'yyyy-MM' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="permaId">
        <th mat-header-cell *matHeaderCellDef>Perma ID</th>
        <td mat-cell *matCellDef="let element">{{ element.permaId }}</td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td mat-cell *matCellDef="let element">{{ element.description }}</td>
      </ng-container>
      <ng-container matColumnDef="decision">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Decision</th>
        <td mat-cell *matCellDef="let element">
          <mat-icon *ngIf="element.decision" style="color: green"
            >check_circle</mat-icon
          >
          <mat-icon *ngIf="element.decision == false" style="color: red"
            >cancel</mat-icon
          >
          <mat-icon *ngIf="element.decision == null">help</mat-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="paid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Paid</th>
        <td mat-cell *matCellDef="let element">
          <mat-icon *ngIf="element.paid" style="color: green"
            >check_circle</mat-icon
          >
          <mat-icon *ngIf="element.paid == false" style="color: red"
            >cancel</mat-icon
          >
          <mat-icon *ngIf="element.paid == null">help</mat-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <a
            mat-raised-button
            [routerLink]="[
              '/admin/accounts/' +
                account.permaId +
                '/licences/' +
                element.permaId
            ]"
            >Edit</a
          >
          <a mat-raised-button (click)="copyToYear(element)">Copy to 2023</a>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedLicenceColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedLicenceColumns"></tr>
    </table>
  </div>
</mat-card>
